import { Alert, Box, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { areLocationScopesEqual, formatLocationScopeLabel } from '../helpers/locationScopes';
import { locationStatusKey } from '../helpers/adminLocationStatus';

const labels = { up_to_date: 'Todo está al día', needs_review: 'Requiere revisión' };

export default function AdminLocationStatusEditor({ locations, statuses, drafts, onChange, disabled, loading, error, description = 'El estado se aplica a todos los usuarios de la sede. Los cambios se guardan al pulsar Guardar cambios.', confirmationHelperText = 'Todo está al día envía un correo a los administradores.' }) {
  return (
    <Stack spacing={1.25} sx={{ gridColumn: '1 / -1', mt: 1 }}>
      <Box>
        <Typography variant="subtitle2">Datos correctos</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
      {error && <Alert severity="warning">No se pudo consultar el estado actual. {error}</Alert>}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, minmax(0, 1fr))' }, gap: 1.25 }}>
        {locations.map((location, index) => {
          const current = statuses.find((entry) => areLocationScopesEqual(entry.locationScope, location));
          const key = locationStatusKey(location);
          const pendingCount = Number(current?.pendingRequestsCount || 0);
          const isIncomplete = !location.country || !location.state || !location.city;
          return (
            <Paper key={`${key}-${index}`} variant="outlined" sx={{ p: 1.25, minWidth: 0 }}>
              <Stack spacing={1}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{formatLocationScopeLabel(location) || `Sede ${index + 1}`}</Typography>
                <TextField
                  select
                  fullWidth
                  label={`Datos correctos ${index + 1}`}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ displayEmpty: true }}
                  value={drafts[key] || ''}
                  sx={{ '& .MuiSelect-select': { color: (drafts[key] || current?.status) === 'up_to_date' ? 'success.main' : 'warning.main' } }}
                  onChange={(event) => onChange(location, event.target.value)}
                  disabled={disabled || loading || isIncomplete}
                  helperText={pendingCount
                    ? `${pendingCount} solicitud(es) pendiente(s); no se puede marcar Todo está al día.`
                    : confirmationHelperText}
                >
                  <MenuItem value="">Mantener estado actual: {labels[current?.status] || labels.needs_review}</MenuItem>
                  <MenuItem value="up_to_date" disabled={pendingCount > 0} sx={{ color: 'success.main' }}>Todo está al día</MenuItem>
                  <MenuItem value="needs_review" sx={{ color: 'warning.main' }}>Requiere revisión</MenuItem>
                </TextField>
                {current?.updatedAtLabel && (
                  <Typography variant="caption" color="text.secondary">
                    Última actualización: {current.updatedAtLabel} · {current.updatedByName || current.updatedByEmail}
                  </Typography>
                )}
                {current?.confirmedAtLabel && (
                  <Typography variant="caption" color="text.secondary">
                    Última confirmación: {current.confirmedAtLabel} · {current.confirmedByName || current.confirmedByEmail}
                  </Typography>
                )}
              </Stack>
            </Paper>
          );
        })}
      </Box>
    </Stack>
  );
}
